import TranslationResolver from "./TranslationResolver";

export interface ServiceConfigTranslateArgs {
  moduleName: string;
  lang: string;
  serviceConfig: any;
  resolver: TranslationResolver;
}

export function translateTitle(moduleName: string, lang: string, title: any, resolver: TranslationResolver) {
  if (title === '') return title;

  const rtn = resolver.translate({
    module: moduleName,
    field: "_title",
    lang,
    scope: "service",
    fallback: title || moduleName,
  });
  console.log('translate.title',moduleName,lang,title,rtn);
  return rtn;
}

export function translateGrid(moduleName: string, lang: string, grid: any[], resolver: TranslationResolver) {
  return (grid || []).map((item: any) => {
    const field = Array.isArray(item) ? item[0] : item?.id;
    const label = Array.isArray(item) ? item[1] : item?.label;

    if (Array.isArray(item)) {
      return [
        field,
        resolver.translate({
          module: moduleName,
          field,
          lang,
          scope: "grid",
          fallback: label || field,
        }),
      ];
    }

    return {
      ...item,
      label: resolver.translate({
        module: moduleName,
        field,
        lang,
        scope: "grid",
        fallback: label || field,
      }),
    };
  });
}

export function translateMenu(moduleName: string, lang: string, menu: any, resolver: TranslationResolver) {
  if (!menu) return menu;

  return {
    ...menu,
    mnu: (menu.mnu || []).map((item: any) => ({
      ...item,
      t: resolver.translate({
        module: moduleName,
        field: item.v,
        lang,
        scope: "menu",
        fallback: item.t || item.v,
      }),
    })),
  };
}

export function translateEform(moduleName: string, lang: string, eform: any[], resolver: TranslationResolver) {
  return (eform || []).map((item: any) => ({
    ...item,
    label: resolver.translate({
      module: moduleName,
      field: item.id,
      lang,
      scope: "eform",
      fallback: item.label || item.id,
    }),
  }));
}

export function translateService(moduleName: string, lang: string, service: any, resolver: TranslationResolver) {
  if (!service) return service;
  return {
    ...service,
    title: translateTitle(moduleName, lang, service.title, resolver),
    grid: translateGrid(moduleName, lang, service.grid, resolver),
    menu: translateMenu(moduleName, lang, service.menu, resolver),
    eform: translateEform(moduleName, lang, service.eform, resolver),
  };
}

export function translateServiceConfig(args: ServiceConfigTranslateArgs) {
  const { moduleName, lang, serviceConfig, resolver } = args;
  if (!serviceConfig) return serviceConfig;

  return {
    ...serviceConfig,
    service: translateService(moduleName, lang, serviceConfig.service, resolver),
  };
}
